import { render, staticRenderFns } from "./BuyBoxRow.vue?vue&type=template&id=46656460&scoped=true&"
import script from "./BuyBoxRow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BuyBoxRow.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BuyBoxRow.vue?vue&type=style&index=0&id=46656460&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46656460",
  null
  
)

export default component.exports